import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { Tab } from 'src/app/models/Tab';
import { NavaidsService } from 'src/app/services/navaids.service';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['../footer.component.scss','./tabs.component.scss'],
  standalone: false
})
export class TabsComponent implements OnInit {
  @Input() tabs;
  selectedIndex = 1;
  abc: string;
  leftTabIdx = 0;
  atStart = true;
  atEnd = false;
  minNumberTabsActivatesScroll = 6
  @Output() emitSelectedTab = new EventEmitter()
  @Output() footerStateChange = new EventEmitter<{active: boolean, minimized: boolean}>();

  tabName: string = '';
  constructor(public navaidsController: NavaidsService,
    public menuService: MenuManagementService,
    public tabsService: TabsService
  ) { }

  emitFooterState() {
    this.footerStateChange.emit({
      active: this.tabsService.footerActive,
      minimized: this.tabsService.minimizeScreenMode
    });
  }

  // Call this after minimize/fullscreen actions
  onMinimize() {
    this.tabsService.minimizeWindow();
    this.emitFooterState();
  }
  onFullscreen() {
    this.tabsService.fullScreenWindow();
    this.emitFooterState();
  }

  getTabName(tab: Tab) {
    if (tab.header == null)
      return tab.type;
    return tab.header;
  }

  ngOnInit() {
    if(this.tabs != undefined){
      this.emitSelectedTab.emit(this.tabs[0]);
    }
    this.abc = `translateX(0px)`;
    // Emit initial state
    this.emitFooterState();
  }

  selectTab(index) {
    this.selectedIndex = index;
    this.emitSelectedTab.emit(this.tabs[index]);
    this.scrollTab(index-this.leftTabIdx-1);
    this.emitFooterState();
  }

  scrollTab(x) {
    if (this.atStart && x < 0 || this.atEnd && x > 0) {
      return;
    }
    this.leftTabIdx = this.leftTabIdx + x;
    this.abc = `translateX(${(this.leftTabIdx) * -140}px)`;
    this.atStart = this.leftTabIdx === 0;
    this.atEnd = this.leftTabIdx === this.tabsService.tabs.length -1;
    this.emitFooterState();
  }
  
  getNumberOfVisibleTabs(){
    this.emitFooterState();
    return this.tabsService.tabs.filter(tab => tab.visible).length;
  }

  toggle(i:number){
    if(i != this.tabsService.currentIndex  || this.tabsService.minimizeScreenMode || !this.tabsService.switchTabBlocked) {
      this.tabsService.showTab(i,false,false,true)
      this.emitFooterState();
    }
  }

  closeTab(i){
    if(this.getNumberOfVisibleTabs() == this.minNumberTabsActivatesScroll){
      this.abc = `translateX(0px)`;
      this.leftTabIdx = 0;
    }
    this.tabsService.closeTab(i)
    this.emitFooterState();
  }
}
